 function get_facet_current(){
    jQuery(".collection-products-algolia ul.ais-RefinementList-list").each(function(){ var st222 = "";
  jQuery(this).find("li").each(function(i){//console.log(i);
  var ck_text = jQuery(this).find("input[type='checkbox']"); 
  var me = jQuery(this);
     if(me.find("input[type='checkbox']").is(":checked")){
       st222 = st222 + me.find(".ais-RefinementList-label-txt").text() + ", " }; //console.log(jQuery(this).parent().find(".ais-RefinementList-label-txt").text());
  });//console.log( st222);
       if(jQuery(this).parent().find(".collection__filter-item-active").length <= 0 ){
     jQuery('<span class="collection__filter-item-active">'+ st222 +'</span>').insertBefore(jQuery(this)); }else{
         jQuery(this).parent().find(".collection__filter-item-active").text(st222);
     }
})
  
  }

  function replace_vendor_logo(){
    //replace vendor logo
    var count_loop = 1;
    console.log("vao roi");
    if (count_loop  == 1){
jQuery(".collection-products-algolia ol.ais-Hits-list .ais-Hits-item").each(function(){
	var url_vendor = jQuery(this).find(".ais-hit--vender img").attr("fgc").toLowerCase(); 
 //  var var src_vendor_name= src_vendor.split("?");
	var src_vendor = jQuery(this).find(".ais-hit--vender img").attr("src").toLowerCase(); 
	var src_vendor_split= src_vendor.split("?");
	//console.log(src_vendor_split[0]);
	var  src_vendor_fine = src_vendor_split[0] +   url_vendor.split(' ').join('-'); //url_vendor.replace(' ', '-'); only replace the first space
	jQuery(this).find(".ais-hit--vender img").attr("src",src_vendor_fine);
			})
      }
    count_loop++;
    console.log('count_loop'+count_loop);
  }
  function show_vendor(){
     jQuery(".collection-products-algolia p.ais-hit--vender").each(function(){
    jQuery(this).css("visibility","visible");
  })
  }
jQuery(window).load(function(){
   if(jQuery(".collection-products-algolia .ais-Pagination").length >0 ){
     jQuery(".collection-products-algolia .ais-page .ais-Pagination-item.ais-Pagination-item--nextPage").prev().addClass("ais-Pagination-item-count");
  }
  //close popup dropship on product page 
  jQuery(document).on("click","#modal-quick-view-dropship .close_modal",function(){
    jQuery(this).parent().parent().attr("aria-hidden","true");
    jQuery("html").removeClass("is-locked");
  })
//replace_vendor_logo();
 // show_vendor();
 
$(".collection-products-algolia ul.ais-RefinementList-list li").click(function() {
   setTimeout(function() { 
    // replace_vendor_logo();show_vendor();
  //console.log(333);
   }, 1000);  
});
$(".ais-Pagination-link").click(function() {
   setTimeout(function() {
    // replace_vendor_logo();show_vendor();
     console.log("click paging");
   }, 1000);
});

  $(".ais-ClearRefinements-button").click(function() {
   setTimeout(function() {
     replace_vendor_logo();show_vendor();
   }, 1000);
});

  //for mobile  filter open
var w_window = jQuery(window).width();
if(w_window <= 767){
  //add value selected for filter mobile
get_facet_current();
  jQuery(".collection-products-algolia .collection__filter-group-div").insertAfter(".collection-products-algolia #mobile-collection-filters-algolia .collection-drawer__header");
  jQuery(".collection-products-algolia .ais-page .ais-facet--header").each(function(i){
    jQuery(this).addClass("opened");
 //   console.log(i);
  })
  //convert sort to ul
  $('.collection-products-algolia .ais-page .ais-SortBy-select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
  
    $this.addClass('select-hidden'); 
   // $this.wrap('<div class="select"></div>');
   // $this.after('<div class="select-styled"></div>');

   // var $styledSelect = $this.next('div.select-styled');
   // $styledSelect.text($this.children('option').eq(0).text());
  
    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter(".collection-products-algolia #sort-by-selector .value-picker__header");
  $(".collection-products-algolia ul.select-options").wrap('<div class="value-picker__choice-list"></div>')
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
        //if ($this.children('option').eq(i).is(':selected')){
        //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
        //}
    }
  
    var $listItems = $list.children('li');
  
   // $styledSelect.click(function(e) {
     //   e.stopPropagation();
     //   $('div.select-styled.active').not(this).each(function(){
      //      $(this).removeClass('active').next('ul.select-options').hide();
      //  });
      //  $(this).toggleClass('active').next('ul.select-options').toggle();
    //});
  $listItems.each(function(){
    $(this).append('<svg focusable="false" class="icon icon--check-2 " viewBox="0 0 13 11" role="presentation"><path d="M1 4.166456L5.317719 9 12 1" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd"></path></svg>')
  })
    $listItems.click(function(e) {
    $(".collection-products-algolia #sort-by-selector ul.select-options li").removeClass("active");
      $(this).addClass("active");
       // $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel')).change();
       $this.trigger("change");
        //$(".collection-products-algolia #sort-by-selector .value-picker__close").trigger("click");
jQuery(".collection-products-algolia #sort-by-selector").attr("aria-hidden","true");
        document.querySelector('select.ais-SortBy-select').dispatchEvent(new Event('change'));
        e.stopPropagation();
    });
  
    $(document).click(function() {
      //  $styledSelect.removeClass('active');
      //  $list.hide();
       
    });

});
  jQuery(document).on("click",".collection-products-algolia .ais-page div.collection__filter-group ul.ais-RefinementList-list li input",function(){ 
console.log("click1");
  if(jQuery(this).is(":checked"))
  {
   window.setTimeout(count_filter_fgc(1), 3000);
  }else{
    window.setTimeout(count_filter_min(0),3000);
  }
  setTimeout(function() { get_facet_current() }, 2000);

})
  //end
}
  //count filter
  var count_filter = jQuery(".collection-products-algolia ul.ais-current-refined-values--list li.ais-current-refined-values--item").length;
  jQuery(".collection-products-algolia  .count-filter").text(count_filter);
  jQuery(".collection-products-algolia .collection-drawer__filter-count").text("("+count_filter+")");
  jQuery(".ais-page .ais-stats--nb-results").insertBefore(".collection-products-algolia .ais-page .ais-search-header span.ais-Stats-text"); 

})
//update filter current seleced

function count_filter_fgc(i){
   var count_filter_12  = jQuery(".collection-products-algolia ul.ais-current-refined-values--list li.ais-current-refined-values--item").length;
  var count_final =  count_filter_12 + i;
  jQuery(".collection-products-algolia  .count-filter").text(count_final);
  jQuery(".collection-products-algolia .collection-drawer__filter-count").text("("+count_final+")");
}
function count_filter_min(i){
   var count_filter_min  = jQuery(".collection-products-algolia ul.ais-current-refined-values--list li.ais-current-refined-values--item").length;
  var count_final_min =  count_filter_min - 1;
  jQuery(".collection-products-algolia  .count-filter").text(count_final_min);
  jQuery(".collection-products-algolia .collection-drawer__filter-count").text("("+count_final_min+")");
}
  
  

jQuery(document).on("click",".collection-products-algolia ul.ais-current-refined-values--list li.ais-current-refined-values--item",function(){ 
console.log("click");
window.setTimeout(count_filter_min(1),1000);

})
//clear filter click
jQuery(document).on("click",".collection-products-algolia #mobile-collection-filters-algolia .collection-drawer__header button[data-action='clear-filters'],.collection-products-algolia .ais-page .clear-all .ais-ClearRefinements-button",function(){
  jQuery(".collection-products-algolia .ais-page .ais-clear-refinements-container button, .collection-products-algolia .ais-page .ais-clear-refinements-container .ais-ClearRefinements-button").trigger("click");
jQuery(".collection-products-algolia .ais-page #mobile-collection-filters-algolia ").attr("aria-hidden",true);//close modal
  //re count
  // var count_filter_re = jQuery(".collection-products-algolia ul.ais-current-refined-values--list li.ais-current-refined-values--item").length;
  jQuery(".collection-products-algolia  .count-filter").text(0);
  jQuery(".collection-products-algolia .collection-drawer__filter-count").text("(0)");
  jQuery(".collection-products-algolia span.collection__filter-item-active").remove();
})
  
//toggle fillter algolia search
jQuery(document).on("click",".collection-products-algolia .ais-page .ais-facet--header",function(){
  console.log(555);
  //jQuery(this).find(".ais-facet-content").slideToggle();
  jQuery(this).toggleClass("opened");
  jQuery(this).find(".ais-facet-content").toggleClass("opened");
})
//close filter
jQuery(document).on("click",".collection-products-algolia .ais-page  .collection-drawer__close,.collection-products-algolia .ais-page div.collection-drawer__footer button",function(){jQuery(".collection-products-algolia .ais-page #mobile-collection-filters-algolia").attr("aria-hidden",true)})

//click filter
  jQuery(document).on("click",".collection-products-algolia .ais-page  .collection__toolbar button.collection__toolbar-item ",function(){  console.log(66);
    jQuery(".collection-products-algolia .ais-page #mobile-collection-filters-algolia").attr("aria-hidden",false)})
  jQuery(document).on("click",".collection-products-algolia .ais-page  .collection__toolbar-item.collection__toolbar-item--sort button.value-picker-button ",function(){ 
    console.log("Click sort_by");
//jQuery(" .collection-products-algolia #sort-by-selector").slideToggle();
    })

//end search algolia
jQuery(document).ready(function(){

  $(document).on("click","#modal-quick-view-dropship .close_modal",function(){$(this).parent().parent().trigger("click");})

 //convert select to ul for variable on categorypage
 
   $(document).on("click",'.template-collection  div.select-styled-custom',function(e) {
        e.stopPropagation();
        $('.template-collection  div.select-styled-custom.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options-custom').hide();
        });
        $(this).toggleClass('active').next('ul.select-options-custom').toggle();
    });
  
   $(document).on("click",".template-collection  ul.select-options-custom li",function(e) {
        e.stopPropagation();
        $(this).parent().parent().find(".select-styled-custom").text($(this).text()).removeClass('active');
         $(this).parent().parent().find(".select-add-to-cart").val($(this).attr('rel')).trigger("click").change();//selected option for select
         $(".template-collection  ul.select-options-custom").hide();
    });
//console.log(showaddtocart());
  //end

  
 //convert select to ul for variable on product page
$('.template-product .product-form__variants .product-form__option .select-wrapper select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
  
    $this.addClass('select-hidden'); 
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());
  
    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);
  
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val(),
            class:$this.children('option').eq(i).attr("class"),
        }).appendTo($list);
        //if ($this.children('option').eq(i).is(':selected')){
        //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
        //}
    }
  
    var $listItems = $list.children('li');
  
    $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });
  
    $listItems.click(function(e) {
    
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel')).trigger("click");;//selected option for select
      var option_selected =$(this).attr('rel');
        $list.hide();
      // $this.find('option').attr('selected', '');
       // $this.find('option[value="'+option_selected+'"]').trigger("click")
      //  $(".product-form__single-selector").trigger("click");
      // console.log($this);//select
       //alert($("#mounth option:selected").val());
    });
  
    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
       
    });

});
  //end
    $(document).on("click",".show-more-swatch",function() {

    $(this).closest('.hide-UL-element').addClass('hide');
    $(this).closest('div').find('.show-UL-element').addClass('show');
   
})
$(document).on("click",".show-less-swatch",function() {

    $(this).closest('.show-UL-element').removeClass('show');
    $(this).closest('div').find('.hide-UL-element').removeClass('hide');
   
})

  

  // Level 1 circle injection removed — L1 uses full-width rectangle JPGs only.

  var navAssetBase = "//www.workwearhub.com.au/cdn/shop/t/295/assets/";

  function buildNavCircleHtml(imageUrl, altText) {
    return '<div class="menu-img-circle"><img alt="' + (altText || '') + '" loading="lazy" role="presentation" src="' + imageUrl + '"></div>';
  }

  function injectNavCircle($target, imageUrl, altText) {
    if (!$target.length || !imageUrl || $target.find('.menu-img-circle').length) {
      return;
    }

    $target.prepend(buildNavCircleHtml(imageUrl, altText));
  }

  // Mobile menu circle images (L2/L3)
  // ---------------------------------
  // L2: assets/{l1-handle}-{l2-handle}.jpg
  // L3: assets/{l1-handle}-{l2-handle}-{title-handle}.jpg
  //     then fall back to assets/{l1-handle}-{title-handle}.jpg
  // L1 rectangles: assets/{menu-title-downcased}.jpg (see mobile-menu.liquid)
  //
  // L3 title is normalized (lowercase, "&" → "and", non-alnum → "-").
  // If the file name differs from the menu title, add a titleAliases entry.
  // Example: Work Boots & Safety Shoes → Mens → Work Boots
  //   → work-boots-safety-shoes-mens-work-boots.jpg
  // Example: Mens → Footwear → Scuff & Bump Cap
  //   → mens-scuff-bump.jpg (via titleAliases)

  function getAssetCircleUrl(parentHandle, childHandle, grandchildHandle) {
    if (!parentHandle || !childHandle) {
      return null;
    }

    return navAssetBase + parentHandle + '-' + childHandle + '.jpg';
  }

  function getL3CircleCandidates(parentHandle, childHandle, linkTitle) {
    var titleHandle = (linkTitle || '').toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    var child = (childHandle || '').toLowerCase();
    var candidates = [];

    // "Shop All" is a utility link — no circle image
    if (titleHandle === 'shop-all') {
      return [];
    }

    // Context-specific "New Arrivals" art under Footwear / Safety / Workwear
    // and under Work Boots & Safety Shoes → Mens / Womens
    if (titleHandle === 'new-arrivals') {
      var newArrivalSuffixes = {
        footwear: 'new-arrivals-boots',
        safety: 'new-arrivals-safety',
        workwear: 'new-arrivals-workwear',
        mens: 'new-arrivals-boots',
        womens: 'new-arrivals-boots'
      };

      if (newArrivalSuffixes[child]) {
        candidates.push(newArrivalSuffixes[child]);
      }
    }

    // Map normalized L3 menu title → asset filename suffixes (tried in order).
    // Key: titleHandle. Value: suffixes without parent/L2 prefix or ".jpg".
    // Prefer: {parent}-{child}-{suffix}.jpg then {parent}-{suffix}.jpg
    var titleAliases = {
      'steel-cap-boots': ['steel-cap-boots', 'steel-cap'],
      'scuff-and-bump-cap': ['scuff-bump', 'scuff-and-bump-boots'],
      'scuff-bump-cap': ['scuff-bump', 'scuff-and-bump-boots'],
      'non-safety': ['non-safety', 'non-safety-copy'],
      'anti-static': ['anti-static', 'static'],
      'zip-side': ['zip-side', 'zip-side-boots'],
      'elastic-side': ['elastic-side', 'elastic-side-boots'],
      'work-boots': ['work-boots', 'work-boots-1'],
      'safety-shoes': ['safety-shoes', 'safety-shoes-1'],
      'steel-cap': ['steel-cap-boots', 'steel-cap'],
      'healthcare': ['healthcare', 'healthcare-1'],
      'hospitality': ['hospitality', 'hospitality-1'],
      'first-aid': ['first-aid', 'first-aid-1'],
      'kids': ['kids', 'kids-1', 'kids-2'],
      'new-arrivals': ['new-arrivals', 'new-arrivals-1', 'new-arrivals-boots'],
      'on-sale': ['on-sale', 'clearance'],
      'tool-belts-and-accessories': ['tool-belts-and-accessories', 'tool-belts-accessories'],
      'shoe-care': ['shoe-care'],
      'hair-and-skin-care': ['hair-skin-care'],
      'sun-care': ['sun-care'],
      'sock-savers': ['sock-savers'],
      'bags-and-cooler-products': ['bags-cooler-products'],
      'cuffed-work-pants': ['cuffed-work-pants'],
      'taped-pants': ['taped-pants'],
      'fxd-pants': ['fxd-pants'],
      'fxd-shorts': ['fxd-shorts'],
      'bisley-pants': ['bisley-pants'],
      'bisley-shorts': ['bisley-shorts'],
      'hi-vis-shirts': ['hi-vis-shirts'],
      'long-sleeve-shirts': ['long-sleeve-shirts'],
      'short-sleeve-shirts': ['short-sleeve-shirts'],
      'shirts-and-tops': ['shirts-tops'],
      'jackets-and-jumpers': ['jackets-jumpers'],
      'hats-and-beanies': ['hats-beanies'],
      'eyewear-and-sunglasses': ['eyewear-sunglasses'],
      'zadie-workwear-pants': ['zadie-pants', 'zadie-workwear-pants'],
      'zadie-workwear-shorts': ['zadie-shorts', 'zadie-workwear-shorts']
    };

    if (titleAliases[titleHandle]) {
      candidates = candidates.concat(titleAliases[titleHandle]);
    } else {
      candidates.push(titleHandle);
    }

    return candidates.filter(function(candidate, index, list) {
      return candidate && list.indexOf(candidate) === index;
    }).reduce(function(urls, candidate) {
      // Prefer L1-L2-title (e.g. work-boots-safety-shoes-mens-work-boots.jpg)
      if (child) {
        urls.push(navAssetBase + parentHandle + '-' + child + '-' + candidate + '.jpg');
      }
      // Fall back to L1-title (e.g. mens-work-boots.jpg under Mens → Footwear)
      urls.push(navAssetBase + parentHandle + '-' + candidate + '.jpg');
      return urls;
    }, []);
  }

  function injectNavCircleWithFallback($target, parentHandle, childHandle, grandchildHandle, altText, linkTitle) {
    var imageUrls = [];

    if (grandchildHandle || linkTitle) {
      imageUrls = getL3CircleCandidates(parentHandle, childHandle, linkTitle || altText);
    } else {
      var imageUrl = getAssetCircleUrl(parentHandle, childHandle, grandchildHandle);
      if (imageUrl) {
        imageUrls = [imageUrl];
      }
    }

    if (!imageUrls.length || $target.find('.menu-img-circle').length) {
      return;
    }

    var $circle = $(buildNavCircleHtml(imageUrls[0], altText));
    var imageIndex = 0;
    var $image = $circle.find('img');

    $image.on('error', function() {
      imageIndex += 1;

      if (imageUrls[imageIndex]) {
        this.src = imageUrls[imageIndex];
        return;
      }

      $circle.remove();
    });

    $target.prepend($circle);
  }

 $('.Level-2').each(function(){
    var parent = $(this).find('.level-2-Images').attr('data-parent-attr');
    var child = $(this).find('.level-2-Images').attr('data-child-attr');
    var imageUrl = $(this).find('.level-2-Images').attr('data-image-url');
    var altText = $(this).find('.level-2-Images').attr('data-alt');
      
    $('.main-level-2 .mobile-menu__nav-link').each(function(){
      if(($(this).attr('data-parent-attr') == parent) && ($(this).attr('data-child-attr') == child)){
        injectNavCircle($(this), imageUrl, altText);
      }
    })
  })

 $('.Level-3').each(function(){
    var parent = $(this).find('.level-3-Images').attr('data-parent-attr');
    var child = $(this).find('.level-3-Images').attr('data-child-attr');
    var grandchild = $(this).find('.level-3-Images').attr('data-grandchild-attr');
    var imageUrl = $(this).find('.level-3-Images').attr('data-image-url');
    var altText = $(this).find('.level-3-Images').attr('data-alt');
      
    $('.main-level-3 .mobile-menu__nav-link').each(function(){
      if(($(this).attr('data-parent-attr') == parent) && ($(this).attr('data-child-attr') == child) && ($(this).attr('data-grandchild-attr') == grandchild)){
        injectNavCircle($(this), imageUrl, altText);
      }
    })
  })

  $('.main-level-2 .mobile-menu__nav-link').each(function(){
    var $link = $(this);

    if ($link.find('.menu-img-circle').length) {
      return;
    }

    injectNavCircleWithFallback(
      $link,
      $link.attr('data-parent-attr'),
      $link.attr('data-child-attr'),
      null,
      $link.find('.list-title').text().trim()
    );
  });

  $('.main-level-3 .mobile-menu__nav-link').each(function(){
    var $link = $(this);

    if ($link.find('.menu-img-circle').length) {
      return;
    }

    injectNavCircleWithFallback(
      $link,
      $link.attr('data-parent-attr'),
      $link.attr('data-child-attr'),
      $link.attr('data-grandchild-attr'),
      $link.find('.list-title').text().trim(),
      $link.attr('data-link-title') || $link.find('.list-title').text().trim()
    );
  });

 jQuery('.logo-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }]
      });


jQuery('.review-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });

jQuery(function () {
    // jQuery('.rte img').not('a > img').each(function() {
    jQuery("#shopify-section-page-full-width-3embed  .p-8  a").each(function () {
      var src = jQuery(this).attr('href');
      jQuery(this).fancybox({
        'hideOnContentClick': true,
        toolbar: true,
        buttons: [
          'fullScreen',
          'close'
        ],

      });
    });
  });
//   jQuery(document).on("click",".nav-bar__linklist .mega-menu__link",function(e){
//  //alert("check");
//      jQuery( "#okendo-reviews-script" ).load( location.href );
// });
//   jQuery( "nav a" ).click(function() {
//     jQuery( "#okendo-reviews-script" ).load( location.href );
//   //	jQuery("").load(location.href);
//  });

   
//     jQuery( ".pagination__nav-item" ).click(function() {
//        // alert( "Handler for .keyup() called." );
//         jQuery("#okendo-reviews-script").load(location.href);
        

//       });
  
  jQuery( ".product-form__add-button" ).click(function( e ) {
 
    e.preventDefault();
    var $aWithId = $('#selected_size');
    if($aWithId.length > 0){
      var selected_val = jQuery("#selected_size").text();
      if(selected_val != ""){
        return true;
      }else{
        $( ".product-form__payment-container" ).after( '<div class="product-form__status-message" style="height: auto;"><p class="alert alert--error custom-error">Please select a size</p></div>' );
        setTimeout(function(){
          jQuery('.product-form__status-message').remove();
        }, 2500);
        return false;
      }
    }
   
  });
  jQuery( ".product-form__single-selector" ).change(function() {
  	jQuery('.product-form__status-message').remove();
});
  
  class Popup {
    classPopupShow =  'popup--show';
    classForBody = 'popup-active';
    classForHTML = 'popup-active-size-guide';
    popup = null;
    closeOnClickOverlay = false;

    constructor(options = {}) {

      if (options.closeOnClickOverlay) {
        this.closeOnClickOverlay = true;
      }

      // check if page has vertical scroll
      this.scrollWidthInit();

      document.addEventListener('click', e => {
        
        // open
        if (e.target.dataset.popupOpen) {
          e.preventDefault();
          this.popup = document.getElementById(e.target.dataset.popupOpen);
          this.show();
        }

        // close
        if (e.target.hasAttribute('data-popup-close') ||
           (e.target.closest('.popup__close') && e.target.closest('.popup__close').hasAttribute('data-popup-close')) ||
           (this.closeOnClickOverlay && e.target.classList.contains('popup__content'))
        ){
          e.preventDefault();
          this.hide();
        }
      })
    }

    scrollWidthInit() {

      function existVerticalScroll() {
        let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
            sh =  document.body.scrollHeight;

        return sh > vh ? true : false;
      }

      let div = document.createElement('div');
  
      div.style.overflowY = 'scroll';
      div.style.width = '50px';
      div.style.height = '50px';
  
      document.body.append(div);
  
      let scrollWidth = div.offsetWidth - div.clientWidth;
  
      div.remove();

      if (existVerticalScroll()) {
        document.documentElement.style.setProperty('--scroll-width', scrollWidth + 'px');
      }
    }

    show() {
      
      if (this.popup) {
        this.popup.classList.add(this.classPopupShow);
      }

      document.body.classList.add(this.classForBody);
      
      var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
		root.classList.add('popup-active-size-guide');
      
      document.html.classList.add(this.classForHTML);
    }

    hide() {

      if (this.popup) {
        this.popup.classList.remove(this.classPopupShow);
      }

      document.body.classList.remove(this.classForBody);
     
      var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
		root.classList.remove('popup-active-size-guide');
    }
  }

  new Popup({
    closeOnClickOverlay: true, // if you want popup to be closed after click on overlay (default: false)
  });
  
});

// function listClick(clicked_id) {
//     let selected_li = document.querySelectorAll(`.common-size-chart__navigation__ul__li`);
//     selected_li.forEach( item => item.classList.remove("-selected-li"));
//     let pointed_li = document.querySelector(`#${clicked_id}`);
//     pointed_li.classList.add("-selected-li");

//     let tabs = document.querySelectorAll('.common-size-chart__chart__tab');
//     tabs.forEach( item => item.classList.remove("-selected"));
//     let pointed_tab = document.querySelector(`#${clicked_id}-content`);
//     pointed_tab.classList.add("-selected");
// }


$('.mobile-cur-sec').click(function(){
$('#mobile-currency-selector .popover__inner').slideToggle();
})

$(document).ready(function(){
$(document).on("click",".popupdatashow",function() {	
 var a = $(this).next().html();	
  $('#popupID').html(a);	
  $('#popupID').addClass('popup--show')	
  var id = $('.footer-popup .common-size-chart__navigation__ul__li:nth-child(2)').attr('id');	
  $('.common-size-chart__chart__tab').removeClass('-selected')	
  var b = '.footer-popup #'+id+'-content';	
  $(b).addClass('-selected')	
});	
$(document).on("click",".form-sizeguid .popup__close",function() {	
 $('#popupID').removeClass('popup--show');	
});	
$(document).on("click",".footer-popup .common-size-chart__navigation__ul__li",function() {	
var id = $(this).attr('id');	
  $('.common-size-chart__chart__tab').removeClass('-selected')	
var a = '.footer-popup #'+id+'-content';	
  	
    $(a).addClass('-selected')	
        	
    });
});

	
